import Parse from 'parse'
import moment from 'moment-timezone'
moment.tz.setDefault('America/Mexico_City');

class Inbox extends Parse.Object {
  constructor() {
    super('Inbox');
  }

  get userName () {
    return this.get('user.name')
  }
  
  get to () {
    return this.get('to')
  }

  get from () {
    return this.get('from')
  }

  get messages () {
    return this.get('messages')
  }

  get title () {
    return this.get('title')
  }

  get fecha () {
    return moment(this.get('createdAt')).format('dddd DD MMMM, YYYY')
  }


  //-- Pointers and relations

  //-- Load

  /*static load (limit = 500, skip = 0) {
    return new Parse.Query(this)
      .limit(limit)
      .skip(skip)
      .ascending('category')
      .include('to')
      .select([
        'to',
        'user.name',
        'from',
        'title',
        'messages',
        'createdAt'
      ])
      .find()
  }
  */
  static load(params) {
    return Parse.Cloud.run('historyInbox', params)
  }

  //-- CloudFunctions
  
  

  static saveMessageHome(params) {
    console.log('saveMessageHome')
    return Parse.Cloud.run('signUpNotification', params)
  }

  static saveMessage(params) {
    return Parse.Cloud.run('writeMessage', params)
  }

  static responseMessage(params) {
    return Parse.Cloud.run('responseMessage', params)
  }

  static inboxDelete(params) {
    return Parse.Cloud.run('inboxDelete', params)
  }

  

  /*static writeMessageUser(params) {
    return Parse.Cloud.run('writeMessage', params)
  }*/

  dump () {
    console.log(this)
  }
}

export default Inbox
